import { combineReducers } from 'redux';
import { persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import {
	setLoginDetails,
	setSocialLoginUserDetail,
} from './userAuthentication/userAuth.reducer';
import { setUserDetails } from './userDetails/userDetails.reducer';
import { setCourseDetails } from './myCourse/myCourse.reducers';
import { setUtilsDetails } from './utilities/utils.reducer';
import { selectCourse } from './changeCourse/changeCourse.reducers';
import { profileState } from './profile/profile.reducer';
import { myStepDetails } from './mystep/mystep.reducer';
import { setNotifications } from './notifications/notifications.reducer';
import { testPageState } from './testPage/testPage.reducer';
import { buyCourse } from './buyCourse/buyCourse.reducer';
import { settingsDetails } from './settings/settings.reducers';
import { ssoDetails } from './sso/sso.reducer';
import { parentDashboardDetails } from './parentDashboard/parentDashboard.reducer';
import { PURGE, REHYDRATE } from 'redux-persist';
import {
	initialBuyCourseState,
	initialCourseState,
	initialParentDashboardState,
	initialProfileState,
	initialTestPageState,
} from './initialState';

const migrations = {
	0: (state) => ({
		...state,
	}),
	1: (state) => ({
		...state,
		myStepDetails: {
			...state.myStepDetails,
			score: {
				...state.myStepDetails.score,
				showScore: true,
			},
		},
	}),
};

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['loginDetails', 'userDetails'],
	blacklist: ['myCourse'],
	version: 1,
	migrate: createMigrate(migrations, { debug: false }),
	stateReconciler: autoMergeLevel2,
};

const testPagePersistConfig = {
	key: 'testPageState',
	storage: storage,
	blacklist: ['showReview', 'showThankModal'],
};

const profilePersistConfig = {
	key: 'profileState',
	storage: storage,
	blacklist: [
		'showSubscribe',
		'isSubscribe',
		'editProfile',
		'showVerifyMob',
		'getUserInfo',
	],
};

const myCoursePersistConfig = {
	key: 'myCourse',
	storage: storage,
	whitelist: ['unitName', 'elementName', 'previewMode'],
};

const parentPersistConfig = {
	key: 'parentDashboardDetails',
	storage: storage,
	whitelist: ['parentName', 'childrenList', 'childToken', 'activeChildId'],
};

const buyCoursePersistConfig = {
	key: 'buyCourse',
	storage: storage,
	whitelist: ['productData', 'currentProductId'],
};

const appReducer = combineReducers({
	socialAuth: setSocialLoginUserDetail,
	loginDetails: setLoginDetails,
	userDetails: setUserDetails,
	myCourse: persistReducer(myCoursePersistConfig, setCourseDetails),
	utils: setUtilsDetails,
	changeCourse: selectCourse,
	profileDetails: persistReducer(profilePersistConfig, profileState),
	myStepDetails,
	notifications: setNotifications,
	testPageDetails: persistReducer(testPagePersistConfig, testPageState),
	buyCourse: persistReducer(buyCoursePersistConfig, buyCourse),
	settingsDetails,
	ssoDetails,
	parentDetails: persistReducer(parentPersistConfig, parentDashboardDetails),
});

const rootReducer = (state, action) => {
	if (action.type === REHYDRATE && state.loginDetails.resetState) {
		return Object.assign(
			{},
			state,
			{ profileDetails: { ...initialProfileState } },
			{ myCourse: { ...initialCourseState } },
			{ testPageDetails: { ...initialTestPageState } },
			{ buyCourse: { ...initialBuyCourseState } },
			{ parentDetails: { ...initialParentDashboardState } },
		);
	}
	if (action.type === PURGE) {
		storage.removeItem('persist:root');
		storage.removeItem('persist:profileState');
		storage.removeItem('persist:myCourse');
		storage.removeItem('persist:buyCourse');
		storage.removeItem('persist:parentDashboardDetails');

		return Object.assign(
			{},
			state,
			{ loginDetails: { ...state.loginDetails, resetState: true } },
			{ profileDetails: { ...initialProfileState } },
			{ myCourse: { ...initialCourseState } },
			{ testPageDetails: { ...initialTestPageState } },
			{ buyCourse: { ...initialBuyCourseState } },
			{ parentDetails: { ...initialParentDashboardState } },
		);
	}

	return appReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
